module.exports = __webpack_public_path__ + "media/images/mypage/mymenu_3_ov-bcb929c10662ed751c3756dae5b30485.gif";